import defineReadAutoAction from '~/prix/actions/defineReadAutoAction'
import districtStreetIntersectionReadAction from './districtStreetIntersectionRead.action.json' with { type: 'json' }

const districtStreetIntersectionReadDefinition = defineReadAutoAction(
  districtStreetIntersectionReadAction,
  'districtStreetIntersection',
)

export default districtStreetIntersectionReadDefinition
